/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-local-resource-in-zip-dialog.vue?vue&type=template&id=f54bdf74&"
import script from "./add-local-resource-in-zip-dialog.vue?vue&type=script&lang=js&"
export * from "./add-local-resource-in-zip-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-local-resource-in-zip-dialog.vue?vue&type=style&index=0&id=f54bdf74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports